import { api } from "..";
import { apiPaths } from '@/services/api/paths';

export const getCurrentOrganizationContext = async (): Promise<{
  organizationId: string;
  organizationName: string;
  expiresAt: string;
} | null> => {
  const { data } = await api.get(apiPaths.superAdmin.currentContext);

  const response = data.data;

  return response;
};